import React, { useState } from 'react';

import {
  ChevronLeft,
  ChevronRight
} from 'react-feather';

const SliderPaste = ({ images }) => {

  const [count, setCount] = useState(0);

  const handleNext = () => {
    count >= images.length - 1 ? setCount(0) : setCount(count + 1);
  }

  const handlePrev = () => {
    count <= 0 ? setCount(images.length - 1) : setCount(count - 1);
  }

  return (
    <div className="pics-slider">
      <div>

        <div className="pics-btns">
          <button className="action-btn" onClick={handlePrev}>
            <ChevronLeft size={24} />
          </button>

          <div className="pics">
            <img src={images[count]} />
          </div>

          <button className="action-btn" onClick={handleNext}>
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="dots">
          {images.map((_, index) => {
            return (
              <div className="dot"></div>
            )
          })}
        </div>

      </div>
    </div>
  );
}

export default SliderPaste;